module.exports = __webpack_public_path__ + "assets/img/gz.c294cfa7.jpg";